'use strict';

import GLightbox from 'glightbox'

const SELECTOR = 'js-video-modal';

(function () {
    const element = document.querySelector('.' + SELECTOR);

    if (element === null) {
        return false;
    }
   
    GLightbox({
        selector: SELECTOR,
        videosWidth: 1280
    });

}());
